// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { imageStyles } from "@steiner/Overrides/Widgets/BrandDetails/BrandDetailsImage";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

imageStyles.container = { gap: 0 };

imageStyles.imageItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "xs")} {
            justify-content: center;
        }
    `,
};

imageStyles.linksContainer = {
    css: css`
        display: flex;
        column-gap: 16px;
        align-items: center;
        justify-content: end;
        flex: 1;
        ${xScreen("lte", "xs")} {
            flex-direction: column;
            justify-content: center;
            row-gap: 16px;
        }
    `,
};
